'use client'

import { TypographyVariants } from '@snowball-tech/fractal/dist/src/components/Typography'
import DomPurify from 'isomorphic-dompurify'

import type { CSSProperties } from 'react'

import isEmpty from 'lodash/fp/isEmpty'

type Props = {
  content: string | null | undefined
  className?: string
  style?: CSSProperties
  target?: HTMLAnchorElement['target']
  underlined?: boolean
  variant?: `${TypographyVariants}`
}
export default function ParsedLinks({
  className,
  content,
  style,
  target = '_blank',
  underlined = true,
  variant = TypographyVariants.Body1,
}: Props) {
  if (isEmpty(content)) {
    return content
  }

  const markup = {
    __html: (DomPurify.sanitize(content).replaceAll(
      /(^|[^"])(https?:\/\/\S+)/gi,
      `$1<a class="font-weight-${variant}-link${
        underlined ? ' underline' : ''
      }" href="$2" target="${target}" rel="noreferrer noopener" onclick="event.stopPropagation()">$2</a>`,
    ) ?? content) as string,
  }

  return (
    <div className={className} dangerouslySetInnerHTML={markup} style={style} />
  )
}
